import * as R from 'remeda';
import { UserAction, UserState } from 'store/glue/user';

const initialState: UserState = {
  bearerToken: null,
  // Holds the path to navigate to after the OIDC callback resolves. Stays
  // `null` for the in-app /login flow (which uses the route search param).
  postLoginRedirect: null,
};

const userReducer = (
  state: UserState = initialState,
  action: UserAction,
): UserState => {
  switch (action.type) {
    case 'glue/user/SET_TOKEN': {
      return R.set(state, 'bearerToken', action.payload);
    }
    case 'glue/user/SET_POST_LOGIN_REDIRECT': {
      return R.set(state, 'postLoginRedirect', action.payload);
    }
    default:
      return state;
  }
};

export default userReducer;
